<script>
import PaymentBox from "../PaymentBox.vue";
import Vuex from "vuex";
import axios from "axios";

export default {
    name: "DirectCarbonPay",
    components: {PaymentBox},
    computed: {
        ...Vuex.mapState("directFormData", ['carbon']),
        cost() {
            return this.carbon * 17.16; //  then convert to cost
        }
    },
    methods: {
        async paymentComplete(e, fName, lName, email, anon) {
            console.log(e);
            let options = {
                event_id: this.$store.getters['directFormData/formEvent'],
                anon: anon,
                recurring: false,
                paypal_id: e.id,
                payer_id: e.payer.payer_info.payer_id,
                amount: e.transactions[0].amount.total,
                email: email,
                co2: this.carbon,
                first_name: fName,
                last_name: lName
            };
            if (this.$store.getters["user/isSet"]) {
                options.user_id = await this.$store.getters["user/getItem"]("id");
            }
            axios.post(this.$store.getters["server"] + "/create-direct-contribution", options)
                .then(() => {
                    this.$store.commit("directFormData/reset");
                    this.$router.push("/carbon/paycomplete");
                });
        },
        getOffsetCostWrapScale() {
            let wrap = this.$refs.offsetCostWrap;
            if (wrap) {
                let contentWidth = this.$refs.offsetCostIcon.offsetWidth + this.$refs.offsetCostText.offsetWidth;
                if (contentWidth > wrap.offsetWidth) {
                    return wrap.offsetWidth / contentWidth * 0.8; // 0.8 is a buffer, because I can't include margins
                }
                return 1;
            }
            return 1;
        }

    }
};
</script>

<template>
    <div>
        <h1>Your Carbon Footprint</h1>
<!--        <div class="calculated-item" id="calcDistance">-->
<!--            <div class="calculated-icon">-->
<!--                <i class="fas fa-cloud"></i>-->
<!--                <div class="dollar-overlay">$</div>-->
<!--                <div class="icon-caption"><span class="calc-value">${{cost.toFixed(2)}}</span></div>-->
<!--            </div>-->
<!--        </div>-->
        <div id="calculatedOffsetCostWrap" ref="offsetCostWrap" :style="{transform: 'scale(' + getOffsetCostWrapScale() + ')'}">
            <div class="calculated-icon" ref="offsetCostIcon">
                <div id="calculatedOffsetIcon"><i class="fas fa-cloud"></i>
                    <div class="dollar-overlay">$</div>
                </div>
            </div>
            <div id="calculatedOffsetCost" ref="offsetCostText">
                <div id="calculatedOffsetTotal">${{cost.toFixed(2)}}</div>
                <div id="calculatedOffsetSubtitle">Total Offset Cost</div>
            </div>
        </div>
        <div id="learnMore">Learn about our projects</div>
        <div id="AboutButton">
            <a href="https://nicc-tico2e.getresponsesite.com/" target="_blank" class="button-submit"><span><span class="title"><img
                src="../../assets/NICC-_Favicon-White.png" alt="" class="nicc-icon"> Read More About</span> The National Indian Carbon Coalition's Forest Carbon Projects</span></a>
        </div>
        <payment-box :payment="cost" :callback="paymentComplete"></payment-box>
    </div>
</template>

<style scoped lang="less">
@import (reference) "../../assets/variables.less";
.calculated-icon{
    //font-size: 3em;
    color: @orange;
}
#calculatedOffsetCostWrap {
    display: flex;
    align-items: center;
    justify-content: center;
}

#calculatedOffsetIcon {
    font-size: 7.5rem;
    position: relative;

    .dollar-overlay {
        color: white;
        font-weight: 700;
        font-size: 0.47em;
        position: absolute;
        top: 30%;
        left: 36%;
    }
}
.calc-value{
    color: @text-color;
    font-size: 1.5rem;
    font-family: "Lora", serif;
    font-weight: 700;
}

#calculatedOffsetCost {
    text-align: left;
    position: relative;
    top: -0.5rem;
    margin-left: 1rem;
    font-size: 5rem;
}

#calculatedOffsetTotal {
    font-family: "Lora", serif;
    font-weight: 700;
}

#calculatedOffsetSubtitle{
    text-transform: uppercase;
    color: @light-gray;
    font-weight: bold;
    letter-spacing: 0.05em;
    font-size: 0.2em;
}
#learnMore{
    margin: 1.5rem;
    font-size: 1.3em;
}
img.nicc-icon {
    height: 1em;
}

#AboutButton {
    margin: 2rem auto ;
    padding: 0;
    max-width: 22em
}

</style>



// WEBPACK FOOTER //
// src/components/direct-contribute/DirectCarbonPay.vue